import { UrlMatchResult, UrlSegment } from '@angular/router';

export function rpProductsCategoryMatcher(segments: UrlSegment[]): UrlMatchResult {
  const markerIndex = segments.findIndex((s) => s.path === 'my-products');

  if (markerIndex !== 0 && markerIndex !== 1) {
    return null;
  }

  const categoryIndex = markerIndex + 1;
  const hasCategory = categoryIndex < segments.length;

  const posParams = hasCategory ? {
    categoryCode: segments[categoryIndex],
    ...(markerIndex === 1 && { brand: segments[0] })
  } : undefined;

  return { consumed: segments, posParams };
}
